import { object, number, string, collection } from '@gogame/schemas';

import { costModelsSchema } from 'scenes/Campaigns/components/Form/CostModels/schema';

import {
  CAMPAIGN_NAME,
  CAMPAIGN_ALTERNATIVE_ID,
  CAMPAIGN_PLATFORM_ID,
  CAMPAIGN_COST_MODELS,
} from './constants';

export const campaignNameSchema = string()
  .default('')
  .required('Campaign name is required');

export const platformCampaignSchema = object({
  [CAMPAIGN_NAME]: campaignNameSchema,
  [CAMPAIGN_ALTERNATIVE_ID]: string(),
  [CAMPAIGN_PLATFORM_ID]: number(),
  [CAMPAIGN_COST_MODELS]: costModelsSchema,
});

export const campaignsSchema = collection(platformCampaignSchema).default([
  platformCampaignSchema.default(),
]);

export function cleanPlatformCampaign(platformCampaign) {
  return platformCampaignSchema.cast(
    {
      [CAMPAIGN_ALTERNATIVE_ID]: platformCampaign[CAMPAIGN_ALTERNATIVE_ID],
      [CAMPAIGN_COST_MODELS]: platformCampaign[CAMPAIGN_COST_MODELS],
    },
    { context: {} }
  );
}

export function createPlatformCampaign(platformCampaign = {}) {
  return platformCampaignSchema.cast(platformCampaign, { context: {} });
}

export function isEmptyCampaign(platformCampaign) {
  return (
    !platformCampaign[CAMPAIGN_NAME] &&
    !platformCampaign[CAMPAIGN_ALTERNATIVE_ID] &&
    !platformCampaign[CAMPAIGN_COST_MODELS]?.length
  );
}
